/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Priority_MediumInputs */

const en_manual_qc_priority_medium = /** @type {(inputs: Manual_Qc_Priority_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium`)
};

const fr_manual_qc_priority_medium = /** @type {(inputs: Manual_Qc_Priority_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moyenne`)
};

const de_manual_qc_priority_medium = /** @type {(inputs: Manual_Qc_Priority_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium`)
};

const it_manual_qc_priority_medium = /** @type {(inputs: Manual_Qc_Priority_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medio`)
};

const ru_manual_qc_priority_medium = /** @type {(inputs: Manual_Qc_Priority_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Середина`)
};

const es_manual_qc_priority_medium = /** @type {(inputs: Manual_Qc_Priority_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medio`)
};

const zh_cn2_manual_qc_priority_medium = /** @type {(inputs: Manual_Qc_Priority_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中等的`)
};

const ja_manual_qc_priority_medium = /** @type {(inputs: Manual_Qc_Priority_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中くらい`)
};

const hi_manual_qc_priority_medium = /** @type {(inputs: Manual_Qc_Priority_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मध्यम`)
};

const pt_pt2_manual_qc_priority_medium = /** @type {(inputs: Manual_Qc_Priority_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Médio`)
};

/**
* | output |
* | --- |
* | "Medium" |
*
* @param {Manual_Qc_Priority_MediumInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_priority_medium = /** @type {((inputs?: Manual_Qc_Priority_MediumInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Priority_MediumInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_priority_medium(inputs)
	if (locale === "de") return de_manual_qc_priority_medium(inputs)
	if (locale === "it") return it_manual_qc_priority_medium(inputs)
	if (locale === "ru") return ru_manual_qc_priority_medium(inputs)
	if (locale === "es") return es_manual_qc_priority_medium(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_priority_medium(inputs)
	if (locale === "ja") return ja_manual_qc_priority_medium(inputs)
	if (locale === "hi") return hi_manual_qc_priority_medium(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_priority_medium(inputs)
	return en_manual_qc_priority_medium(inputs)
});